const hashTagUtils = {
  filterTags: function(tags) {
    const nonHashTags = ["guide", "news"]
    return tags.filter(tag => nonHashTags.indexOf(tag) < 0)
  },
  hashtagsToString: function(hashtags) {
    const defaults = [
      "#btc",
      "#crypto",
      "#cryptocurrencies",
      "#cryptobuyingtips",
      "#blockchain",
      "#binance",
      "#cryptotrading",
    ]
    if (hashtags !== undefined && hashtags.length > 0) {
      return hashtags
        .map(
          hashtag =>
            `#${hashtag.split(" ").join("")} $${hashtag.split(" ").join("")}`
        )
        .concat(defaults)
        .join(" ")
    } else return defaults.join(" ")
  },
}

module.exports = hashTagUtils
